<template>
    <div class="invoice-restart">
        <div class="section-title">请选择重开方式：</div>
        <div class="radio-group">
            <div class="radio-item" @click="selectType(1)">
                <span class="radio-icon" :class="{ active: type === 1 }">
                    <span class="radio-dot" v-if="type === 1"></span>
                </span>
                <div class="radio-content">
                    <span class="radio-label" :class="{ active: type === 1 }">修改发票信息</span>
                    <span class="radio-desc">重新填写开票信息，通过审核后将以新填写的信息重新开具发票</span>
                </div>
            </div>
            <div class="radio-item" @click="selectType(2)">
                <span class="radio-icon" :class="{ active: type === 2 }">
                    <span class="radio-dot" v-if="type === 2"></span>
                </span>
                <div class="radio-content">
                    <span class="radio-label" :class="{ active: type === 2 }">重新选择订单</span>
                    <span class="radio-desc">原订单被释放，通过审核后可至充值历史页重新选择订单进行开票</span>
                </div>
            </div>
        </div>

        <div class="flow-box">
            <div class="flow-title">重开流程</div>
            <img :src="type === 1 ? restartImg1 : restartImg2" alt="重开流程" />
        </div>

        <div class="notice-title">注意事项：</div>
        <ul class="notice-list" v-if="type === 1">
            <li>请仔细核对您填写的发票信息，以免再次修改。</li>
            <li>您提交的请求将由人工审核，审核通过后才会重开。人工审核的时间有可能较长。</li>
            <li>按照新的发票信息重开发票后，旧抬头对应的发票将作废，无法进行报销。</li>
        </ul>
        <ul class="notice-list" v-else>
            <li>您提交的请求将由人工审核，审核通过后才可重开。人工审核的时间有可能较长。</li>
            <li>您的重开请求通过审核后，旧抬头对应的发票将被作废，无法进行报销。</li>
        </ul>
    </div>
</template>

<script>
import restartImg1 from '@/assets/images/invoice/restart1.png'
import restartImg2 from '@/assets/images/invoice/restart2.png'

export default {
    name: 'InvoiceRestart',
    data () {
        return {
            type: 1,
            restartImg1,
            restartImg2
        }
    },
    methods: {
        selectType (val) {
            this.type = val
            this.$emit('change', val)
        }
    }
}
</script>

<style lang="less" scoped>
.invoice-restart {
    .section-title {
        font-size: 14px;
        font-weight: bold;
        color: #0F172A;
        margin-bottom: 16px;
    }

    .radio-group {
        margin-bottom: 20px;
    }

    .radio-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;
        cursor: pointer;

        .radio-icon {
            box-sizing: border-box;
            width: 16px;
            height: 16px;
            min-width: 16px;
            border-radius: 50%;
            border: 1px solid #D0D5DD;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: border-color 0.2s;
            margin-top:3px;
            &.active {
                border-color: #3B7DFF;
            }

            .radio-dot {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: #3B7DFF;
            }
        }

        .radio-content {
            margin-left: 10px;
            display: flex;
            flex-direction: column;

            .radio-label {
                font-size: 14px;
                color: #0F172A;
                font-weight: 600;
                transition: color 0.2s;
                line-height: 22px;
                &.active {
                    color: #3B7DFF;
                    font-weight: bold;
                }
            }

            .radio-desc {
                font-size: 12px;
                color: #64748B;
                margin-top: 4px;
                line-height: 1.5;
            }
        }
    }

    .flow-box {
        border: 1px solid #D0D5DD;
        border-radius: 10px;
        padding: 20px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 24px;

        .flow-title {
            font-size: 14px;
            font-weight: bold;
            color: #0F172A;
            margin-bottom: 16px;
        }

        img {
            max-width: 100%;
            height: auto;
            display: block;
        }
    }

    .notice-title {
        font-size: 14px;
        font-weight: bold;
        color: #0F172A;
        margin-bottom: 12px;
    }

    .notice-list {
        padding-left: 20px;
        margin: 0;

        li {
            font-size: 13px;
            color: #64748B;
            line-height: 1.8;
            list-style-type: decimal;
        }
    }
}
</style>
